// types.ts - Modelos del Chat

export interface User {
  id: string;
  first_name: string;
  last_name?: string;
  email?: string;
  hue: number;
  token?: string;
  timeout_until?: number;
  banned_at?: number;
}

export interface Watcher {
  id: string;
  name: string;
  last_name?: string;
  userHue: number;
  email?: string;
  timeout_until?: number;
  banned_at?: number;
}

export interface Reaction {
  emoji: string;
  users: string[];
}

/*
 * Why something was taken down, recorded alongside `deleted`. Only `ban` is undone by unbanning
 * its author — see setUserContentRemoved in the chat service.
 */
export type RemovalReason = 'author' | 'ban' | 'moderator' | 'system';

export interface Reply {
  senderId: string;
  senderFirst: string;
  senderHue: number;
  messageId: string;
  senderLast?: string;
  pk: string;
  reply: string;
  timestamp: number;
  deleted?: boolean;
  removedBy?: RemovalReason;
}

export interface Message {
  pk: string;
  sk: string;
  senderId: string;
  senderHue: number;
  roomId: string;
  deleted?: boolean;
  removedBy?: RemovalReason;
  replies?: Reply[];
  message: string;
  reactions?: Reaction[];
  timestamp: number;
  senderFirst: string;
  senderLast?: string;
}

export interface WebSocketMessage {
  id?: string;
  action: 'auth' | 'ban' | 'delete' | 'message' | 'reaction' | 'reply' | 'restore' | 'unban' | 'update';
  objectType?: 'CHAT_MESSAGE' | 'CHAT_REACTION' | 'CHAT_REPLY' | 'CHAT_USER';
  senderHue?: number;
  connectionId?: string;
  senderId?: string;
  username?: string;
  roomId?: string;
  message?: string;
  reply?: string;
  messageId?: string;
  emoji?: string;
  userIds?: string[];
  timestamp?: number;
  deleted?: boolean;
  /* Carried on a `delete` so the reason survives a live removal, not just a reload. */
  removedBy?: RemovalReason;
  content?: string;
}

export interface AuthResponse {
  statusCode: number;
  body: {
    message: string;
    messages: Message[];
  };
  success: boolean;
}

export interface WatchersResponse {
  statusCode: number;
  body: {
    message: string;
    watchers: Watcher[];
  };
  success: boolean;
}

export interface MessagesResponse {
  statusCode: number;
  body: {
    message: string;
    messages: Message[];
    has_more: boolean;
  };
  success: boolean;
}

export interface TimeoutRequest {
  mins?: number;
}

export interface ApiResponse {
  statusCode: number;
  body: {
    message: string;
  };
  success: boolean;
}

export type WebSocketStatus = 'connected' | 'connecting' | 'disconnected' | 'error';

export interface ChatState {
  messages: Message[];
  watchers: Watcher[];
  status: WebSocketStatus;
  error: string | undefined;
}
